import React from 'react';

export default function ScreenShot() {
  return (
    <div className='change-screenshot-folder-wrap'>
      <div class='change-screenshot-folder'>
        <div class='text-section'>
          <div class='AnimateUp'>
            <h6>PRO TIP</h6>
          </div>
          <div class='AnimateUp'>
            <h1 class='title'>
              How to customize the folder where your screenshots are saved.
            </h1>
          </div>
        </div>
        <div class='AnimateUp'>
          <div class='image-section'>
            <div class='laptop-image'>
              <img
                src='https://meetshotty.com/static/9a307e19aa83b49db644c463f07a80e4/b7fa1/laptop-hero.png'
                alt='img'
              />
            </div>
          </div>
        </div>
      </div>
      <div className='change-screenshot-folder'>
        <div class='text-section'>
          <h1 class='title'>Declutter your Desktop</h1>
          <p class='body'>
            Here’s how you can set your Mac to save screenshots to a custom
            folder. Shotty will keep working normally.
          </p>
        </div>
      </div>
      <div className='change-screenshot-folder-col'>
        <div class='text-section'>
          <h3 class='caption'>Step 1</h3>
          <h3 class='title'>Press Command+Shift+5</h3>
          <p class='body'>This will bring up Apple’s screenshot tool.</p>
        </div>
        <div className="img-section">
          <img src="https://meetshotty.com/static/0b5b5fa9a98b9f8516bb77bbf54803c6/7d497/keyboard.png" alt="img"/>
        </div>
      </div>
      <div className='change-screenshot-folder-col'>
        <div class='text-section'>
          <h3 class='caption'>Step 2</h3>
          <h3 class='title'>Click “Options”</h3>
          <p class='body'>You’ll set your new folder in the next step.</p>
        </div>
        <div className="img-section">
          <img src="https://meetshotty.com/static/2d1d800865125d24692f7c641f48bae0/7d497/options.png" alt="img"/>
        </div>
      </div>
      <div className='change-screenshot-folder-col'>
        <div class='text-section'>
          <h3 class='caption'>Step 3</h3>
          <h3 class='title'>Choose “Other location...”</h3>
          <p class='body'>Choose any folder on your Mac, or create a new one. This is where your screenshots will be saved from now on. You can change this at any time.</p>
        </div>
        <div className="img-section">
          <img src="https://meetshotty.com/static/b20d2041253712b5ac8d83a09c3bd2ca/7d497/menu.png" alt="img"/>
        </div>
      </div>
      <div class='change-screenshot-folder'>
        <div class='text-section'>
          <div class='AnimateUp'>
            <h6>SWEET!</h6>
          </div>
          <div class='AnimateUp'>
            <h1 class='title'>
              Shotty will show screenshots as they’re added to the new folder.
            </h1>
          </div>
        </div>
        <div class='AnimateUp'>
          <div class='image-section'>
            <div class='laptop-image'>
              <img
                src='https://meetshotty.com/static/168888d9232736f0c1c89918123ce727/9faf2/shotty-hero.png'
                alt='img'
              />
            </div>
          </div>
        </div>
        <div className='button AppStoreButton__Group'>
          <a
            href='https://itunes.apple.com/us/app/shotty/id1250306151?mt=12'
            className='AppStoreButton__Link-oktydz-1 fuxrR'
          >
            <img
              src='https://meetshotty.com/static/app-store-badge-inner-0b7bf2bf9ed36149825e7acd6b83e107.svg'
              className='AppStoreButton__Badge'
            />
          </a>
        </div>
      </div>
    </div>
  );
}
